module.exports = "/work-site/img/crane.5c9cd445.png";